import React from 'react';
import LoadInline from '../loading/LoadInline.js';
import moment from 'moment';
import { Feed, Icon } from 'semantic-ui-react';

import {colors, fontSizes, spacings, layout, shadow} from 'style';
import AnnouncementsFeedItem from './AnnouncementsFeedItem.js';
import './announcements.css';

var style = {
    content: {
        height:'100%'
    },
    body: {
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
        padding: spacings.base,
    },
    feed: {
    },
}

const Announcements = ({announcements, 
                        pinnedAnnouncement, 
                        complete, 
                        busy, 
                        onScroll, 
                        getIcon, 
                        isNew, 
                        isExpired, 
                        setScrollContainer}) => (
    <div className='scrollable' style={style.content} onScroll={onScroll} ref={(el)=>(setScrollContainer(el))}>
        <div style={style.body}>
            <Feed style={style.feed}>
                {Boolean(pinnedAnnouncement) &&
                    <div>
                        <AnnouncementsFeedItem announcement={pinnedAnnouncement} 
                                               getIcon={getIcon}
                                               complete={complete}
                                               isNew={isNew}
                                               isExpired={isExpired} />
                        <br />
                    </div>
                }

                {announcements.map((announcement)=>(
                    <AnnouncementsFeedItem key={announcement.id} 
                                           announcement={announcement} 
                                           getIcon={getIcon}
                                           complete={complete}
                                           isNew={isNew}
                                           isExpired={isExpired} />
                ))}
            </Feed>
            <LoadInline centered style={{...(busy ? {} : {visibility: 'hidden'})}} /> 
        </div>
    </div> 
);


export default Announcements;



// WEBPACK FOOTER //
// ./src/modules/newsfeed/Announcements.js